import { render, staticRenderFns } from "./Yarnboard2.vue?vue&type=template&id=3ed86ba7&scoped=true&"
import script from "./Yarnboard2.vue?vue&type=script&lang=js&"
export * from "./Yarnboard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed86ba7",
  null
  
)

export default component.exports